// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__26iRE","wrapper":"Footer_wrapper__1XGKK","links-wrapper":"Footer_links-wrapper__b34Kp","social":"Footer_social__2B_CM"};